import { db } from '../config/firebase';
import moment from 'moment-timezone';

export let trgrRun = async () => {
  let ref = db.ref(`trigr/trgr_run`);

  let date = new Date().getTime();

  await ref.update({
    ran: date
  });
};

const engage_screen_name = 'girlposts';


export let doubleDigit = async () => {
  let ref
    = db.ref(`engage/${engage_screen_name}/followers_friends_tweets/archive`);

  await ref.value('once').then((data) => {
    data.forEach((date_data) => {

      // let _key = date_data.key;
      // let key = _key.indexOf('_')
    });
  });
};


export let removeArchive = async () => {
  let ref2
    = db.ref(`engage/${engage_screen_name}/followers_friends_tweets/archive`);

  await ref2.remove();
};

export let createLiveRecord = async () => {

  let ref1
    = db.ref(`engage/${engage_screen_name}/followers_friends_tweets/raw_feed`)
    .orderByKey().limitToLast(1);
  let ref2
    = db.ref(`engage/${engage_screen_name}/followers_friends_tweets/live`);

  await ref1.once('value').then((data) => {

    data.forEach((DATA) => {
      let VAL = DATA.val();

      // let total_followers = VAL.total_followers;
      // let total_friends = VAL.total_friends;
      // let total_tweets = VAL.total_tweets;
      // let raw_date = VAL.raw_date;
      let date = VAL.date;

      ref2.update({
        // last_total_followers: total_followers,
        // last_total_friends: total_friends,
        // last_total_tweets: total_tweets,
        // last_raw_date: raw_date,

        last_date: date

        // live_total_followers: 0,
        // live_total_friends: 0,
        // live_total_tweets: 0,
        // live_raw_date: 0
      });
    });
  });
};


export let restructure = async () => {
  let ref1
    = db.ref(`engage/${engage_screen_name}/followers_friends_tweets/raw_feed`)
    .orderByKey();
  let ref2
    = db.ref(`engage/${engage_screen_name}/followers_friends_tweets/archive`);

  await ref1.once('value').then((data) => {

    let last_followers_total = 0;
    let last_friends_total = 0;
    let last_tweets_total = 0;

    data.forEach((DATA) => {
      let raw_data = DATA.val();
      let date = DATA.val().date;

      let day = (String(date.date).length > 1)
        ? date.date
        : '0'.concat(date.date);
      let month = (String(date.months).length > 1)
        ? date.months
        : '0'.concat(date.months);
      let year = date.years;
      let hour = date.hours;

      let ref3 = ref2.child(`${month + '_' + day + '_' + year}`);
      let ref4 = ref3.child(`${hour}`);

      let total_followers = raw_data.total_followers;
      let total_friends = raw_data.total_friends;
      let total_tweets = raw_data.total_tweets;

      ref4.update({
        ...raw_data,
        live_follower_delta: total_followers - last_followers_total,
        live_friends_delta: total_friends - last_friends_total,
        live_tweets_delta: total_tweets - last_tweets_total
      });

      last_followers_total = total_followers;
      last_friends_total = total_friends;
      last_tweets_total = total_tweets;
    });
  });
};


export let rearrange = async () => {
  let ref1 = db.ref(`twtr_60min/${engage_screen_name}`)
    .orderByChild('date');

  let data_array = [];

  await ref1.once('value').then((data) => {
    data.forEach((DATA) => {
      let o = {};
      let d = DATA.val();

      o.total_followers = d.followers;
      o.total_friends = d.friends;
      o.total_tweets = d.tweets;
      o.date = moment.tz(d.date, "America/New_York").toObject();
      o.raw_date = d.date;

      data_array.push(o);
    });
  });

  let ref2 = db.ref(`engage/${engage_screen_name}/followers_friends_tweets`);

  data_array.map(o => {
    return (
      ref2.child('raw_feed').update({
        [o.raw_date]: o
      })
    );
  });

  console.log('data_array:', data_array);
};


// WEBPACK FOOTER //
// ./src/fx/boss.js